import { FETCH_FUNCTIONAL_AREA } from '../actions/types'

export default function (state = [], action) {
  switch (action.type) {
    case FETCH_FUNCTIONAL_AREA:
      state = action.payload.data.functionalArea
      return state
  }
  return state
}
